// Default application currency
export const defaultCurrency = 'GBP';

// Default application locale
export const defaultLocale = 'en-GB';

// List of locales supported by the application
export const supportedLocaleList = [defaultLocale] as const;
